import React from 'react';

export const ForbiddenSvg: React.FC<{ className?: string }> = ({ className = 'w-72 h-48 sm:w-96 sm:h-64' }) => {
  return (
    <svg
      viewBox="0 0 500 300"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} mx-auto transition-all duration-300`}
    >
      {/* Background tracks */}
      <rect x="130" y="80" width="240" height="14" rx="7" fill="#E2E8F0" className="dark:fill-slate-800" />
      <rect x="90" y="115" width="320" height="14" rx="7" fill="#F1F5F9" className="dark:fill-slate-800/60" />
      <rect x="160" y="150" width="180" height="14" rx="7" fill="#E2E8F0" className="dark:fill-slate-800" />

      {/* First "4" */}
      <path
        d="M165 90 L125 170 H175 V205"
        stroke="currentColor"
        strokeWidth="16"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="text-slate-900 dark:text-white"
      />
      <path
        d="M175 130 H110"
        stroke="currentColor"
        strokeWidth="16"
        strokeLinecap="round"
        className="text-slate-900 dark:text-white"
      />

      {/* Shield & Padlock Lock Center "0" */}
      <g transform="translate(250, 140)">
        <path
          d="M-36 -40 L0 -52 L36 -40 V-5 C36 28 0 44 0 44 C0 44 -36 28 -36 -5 Z"
          stroke="currentColor"
          strokeWidth="12"
          fill="none"
          strokeLinejoin="round"
          className="text-slate-900 dark:text-white"
        />
        <path
          d="M-18 -10 H18 V20 H-18 Z"
          fill="#ef4444"
          className="dark:fill-rose-500"
        />
        <circle cx="0" cy="5" r="4" fill="#ffffff" />
      </g>

      {/* "3" */}
      <path
        d="M315 90 H355 L325 135 C345 135 360 148 360 170 C360 190 342 205 320 205 H305"
        stroke="currentColor"
        strokeWidth="16"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        className="text-slate-900 dark:text-white"
      />
    </svg>
  );
};

export default ForbiddenSvg;
